import { ComponentType, PropsWithChildren } from 'react';
import { NextPageWithLayout } from 'src/types/page';

export function pageWithLayout<T>(
  PageLayout: ComponentType<PropsWithChildren<T>>,
  PageContent: ComponentType<T>,
): NextPageWithLayout<T> {
  // @ts-ignore
  const NextPage: NextPageWithLayout<T> = props => <PageContent {...props} />;

  NextPage.getLayout = (page, props) => <PageLayout {...props}>{page}</PageLayout>;

  return NextPage;
}
